import React from 'react';
import styles from './StudentsAcrossSkillsCharTools.module.scss';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';

interface StudentsAcrossSkillsCharToolsProps {}

const StudentsAcrossSkillsCharTools: React.FC<StudentsAcrossSkillsCharToolsProps> = ({}) => {
  const { t } = useAdminTranslation();

  return (
    <div className={styles.tools}>
      <div className={styles.tool}>
        {t('studentMetricsDashboard.charts.studentsAcrossSkills.tools.pass')}
      </div>
      <div className={styles.tool}>
        {t('studentMetricsDashboard.charts.studentsAcrossSkills.tools.failure')}
      </div>
    </div>
  );
};

export default StudentsAcrossSkillsCharTools;
